var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadMedicalCertificate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 102,
    viewBox: "0 0 94 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7984_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.4875 0.51001H0.512543V101.49H93.4875V0.51001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9749 1.02V100.98H1.02508V1.02H92.9749ZM94 0H0V102H94V0Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.313 10.098C37.108 10.404 37.0055 10.506 36.5954 10.812C36.3904 10.608 36.1854 10.404 35.8779 10.302C36.4929 9.79199 36.8004 9.38399 37.108 8.87399C37.108 8.77199 37.108 8.66999 37.2105 8.56799H35.6728V14.178H41.3108C41.7208 14.178 42.0284 14.178 42.2334 14.178V15.096C41.9258 15.096 41.7208 15.096 41.3108 15.096H35.6728V15.402H34.6478C34.6478 15.096 34.6478 14.79 34.6478 14.382V8.56799C34.6478 8.15999 34.6478 7.95599 34.6478 7.64999C34.9553 7.64999 35.1603 7.64999 35.5703 7.64999H41.1058C41.5158 7.64999 41.8233 7.64999 42.0284 7.64999V8.56799C41.7208 8.56799 41.5158 8.56799 41.1058 8.56799H37.313L38.0305 8.77199C38.0305 8.77199 38.0305 8.77199 38.0305 8.97599C38.0305 9.04399 37.9622 9.17999 37.8255 9.38399H40.6958C41.1058 9.38399 41.3108 9.38399 41.5158 9.38399V10.302C41.2083 10.302 41.0033 10.302 40.6958 10.302H39.3631C39.3631 10.302 39.3631 10.37 39.3631 10.506C39.3631 10.71 39.3631 10.914 39.3631 11.22H41.3108C41.7208 11.22 41.9258 11.22 42.1309 11.22V12.138C41.9258 12.138 41.6183 12.138 41.3108 12.138H39.6707C40.0807 12.852 40.7983 13.26 42.2334 13.464C42.0284 13.77 41.9258 13.974 41.8233 14.382C40.3882 13.974 39.6707 13.464 39.0556 12.648C38.5431 13.464 37.8255 13.974 36.5954 14.382C36.4929 14.076 36.2879 13.77 36.0829 13.566C36.6979 13.362 37.0055 13.26 37.4155 13.056C37.928 12.75 38.2356 12.444 38.4406 12.138H37.2105C36.6979 12.138 36.4929 12.138 36.2879 12.138V11.22C36.5954 11.22 36.6979 11.22 37.2105 11.22H38.6456C38.6456 10.914 38.6456 10.812 38.6456 10.404H37.518L37.313 10.098Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.024 12.75C50.024 13.158 50.024 13.26 50.024 13.464C49.819 13.464 49.7165 13.464 49.5114 13.464C50.024 13.974 50.3315 14.28 50.9466 14.586C50.7415 14.79 50.639 14.994 50.434 15.3C49.7165 14.892 49.3064 14.484 48.6914 13.872L49.2039 13.464H48.1788V14.688C48.1788 14.994 48.1788 15.096 47.9738 15.198C47.7688 15.3 47.6663 15.3 47.2563 15.3C46.8462 15.3 46.6412 15.3 46.2312 15.3C46.2312 14.994 46.2312 14.79 46.0262 14.484C46.4362 14.484 46.7437 14.484 46.9487 14.484C47.1538 14.484 47.2563 14.484 47.2563 14.28V13.362H46.3337C46.1287 13.362 46.1287 13.362 45.9237 13.362L46.5387 13.668C46.0262 14.382 45.7186 14.688 45.0011 15.198C44.7961 14.892 44.6936 14.79 44.386 14.586C45.1036 14.178 45.4111 13.872 45.7186 13.362C45.7186 13.362 45.6845 13.362 45.6161 13.362C45.6161 13.158 45.6161 13.056 45.6161 12.648V11.832C45.4111 11.934 45.4111 12.036 45.1036 12.138C45.1036 11.934 45.0011 11.832 44.8986 11.628C44.8986 12.546 44.6936 13.158 44.4886 13.77C44.2835 14.28 44.0785 14.688 43.6685 15.3C43.361 14.994 43.2585 14.892 42.9509 14.586C43.566 13.872 43.771 13.26 43.8735 12.138C43.6685 12.342 43.2585 12.444 43.0534 12.546C43.0534 12.546 42.9509 12.546 42.8484 12.546L42.5409 11.628C42.8484 11.628 43.361 11.322 43.8735 11.118C43.8735 10.812 43.8735 10.71 43.8735 10.302L43.2585 10.71C43.0534 10.098 42.9509 9.68999 42.6434 9.07799L43.2585 8.66999C43.566 9.17999 43.6685 9.48599 43.8735 9.99599V9.68999C43.8735 9.58799 43.8735 9.07799 43.8735 8.77199C43.8735 8.05799 43.8735 7.95599 43.8735 7.64999C44.181 7.64999 44.4885 7.64999 44.8986 7.64999H46.6412C46.6412 7.34399 46.6412 7.24199 46.6412 7.03799H47.6663C47.6663 7.24199 47.6663 7.34399 47.6663 7.54799H49.7165C50.229 7.54799 50.5365 7.54799 50.7415 7.54799V8.36399C50.434 8.36399 50.229 8.36399 49.819 8.36399H47.8713C47.8713 8.56799 47.8713 8.66999 47.7688 8.77199H49.7165C50.1265 8.77199 50.3315 8.77199 50.639 8.77199V9.58799C50.434 9.58799 50.229 9.58799 49.819 9.58799H48.6914C48.8964 9.89399 48.9989 9.99599 49.3064 10.302C49.614 9.99599 49.7165 9.89399 49.9215 9.68999L50.639 10.098C50.3315 10.404 50.229 10.506 49.9215 10.71C50.3315 10.914 50.5365 11.016 50.9466 11.118C50.7415 11.424 50.7415 11.526 50.5365 11.934C50.229 11.832 50.024 11.73 49.819 11.628V12.546L50.024 12.75ZM45.0011 9.99599C45.0011 10.506 45.0011 10.914 45.0011 11.424C45.3086 11.322 45.5136 11.22 45.7186 11.016C45.5136 10.812 45.4111 10.71 45.1036 10.506L45.6161 10.098C45.9237 10.302 46.0262 10.506 46.2312 10.608C46.4362 10.404 46.5387 10.302 46.7437 9.99599H46.0262C45.6161 9.99599 45.4111 9.99599 45.2061 9.99599V9.17999C45.4111 9.17999 45.6161 9.17999 46.0262 9.17999H47.0513C47.0513 9.07799 47.0513 8.97599 47.1538 8.77199H44.8986V9.99599H45.0011ZM46.5387 11.832H49.1014V11.424H46.5387V11.832ZM46.5387 12.75H49.1014V12.342H46.5387V12.75ZM48.5889 10.812C48.2814 10.506 48.1788 10.404 47.9738 9.99599H47.6663C47.4613 10.302 47.3588 10.608 47.0513 10.812H48.5889Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6641 8.87399C51.8691 8.87399 52.0742 8.87399 52.3817 8.87399H54.2268C54.5344 8.87399 54.7394 8.87399 54.9444 8.87399V9.79199C54.7394 9.79199 54.6369 9.79199 54.3293 9.79199H52.4842C52.1767 9.79199 51.9716 9.79199 51.7666 9.79199V8.87399H51.6641ZM51.8691 15.402C51.8691 15.096 51.8691 14.892 51.8691 14.586V13.26C51.8691 12.954 51.8691 12.75 51.8691 12.546C52.0742 12.546 52.2792 12.546 52.5867 12.546H54.0218C54.3293 12.546 54.4318 12.546 54.6369 12.546C54.6369 12.75 54.6369 12.852 54.6369 13.158V14.586C54.6369 14.892 54.6369 15.096 54.6369 15.3H53.8168V14.994H52.7917V15.402H51.8691ZM51.9716 7.64999C52.1767 7.64999 52.3817 7.64999 52.6892 7.64999H53.9193C54.2268 7.64999 54.4318 7.64999 54.6369 7.64999V8.46599C54.4318 8.46599 54.2268 8.46599 53.9193 8.46599H52.6892C52.3817 8.46599 52.1767 8.46599 51.9716 8.46599V7.64999ZM51.9716 10.2C52.1767 10.2 52.2792 10.2 52.5867 10.2H54.1243C54.4318 10.2 54.5344 10.2 54.6369 10.2V11.016C54.4318 11.016 54.3293 11.016 54.1243 11.016H52.5867C52.2792 11.016 52.1767 11.016 51.9716 11.016V10.2ZM51.9716 11.322C52.1767 11.322 52.2792 11.322 52.5867 11.322H54.1243C54.4318 11.322 54.5344 11.322 54.6369 11.322V12.138C54.4318 12.138 54.3293 12.138 54.0218 12.138H52.4842C52.1767 12.138 52.0742 12.138 51.9716 12.138V11.322ZM52.7917 14.178H53.8168V13.362H52.7917V14.178ZM56.9945 8.66999H55.9695C55.5594 8.66999 55.2519 8.66999 54.9444 8.66999V7.64999C55.2519 7.64999 55.5594 7.64999 55.9695 7.64999H58.5322C58.9422 7.64999 59.2497 7.64999 59.5573 7.64999V8.66999C59.2497 8.66999 58.9422 8.66999 58.5322 8.66999H57.8146V10.812H58.5322C58.9422 10.812 59.1472 10.812 59.3522 10.812V11.832C59.1472 11.832 58.9422 11.832 58.5322 11.832H57.8146V14.382H58.6347C59.0447 14.382 59.3522 14.382 59.5573 14.382V15.402C59.2497 15.402 58.9422 15.402 58.5322 15.402H55.5594C55.1494 15.402 54.8419 15.402 54.6369 15.402V14.382C54.8419 14.382 54.9444 14.382 55.1494 14.382V11.118C55.1494 10.71 55.1494 10.506 55.1494 10.2H56.1745C56.1745 10.506 56.1745 10.71 56.1745 11.118V14.382H56.9945V8.87399V8.66999Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1319 20.91H6.15048V95.064H87.1319V20.91Z",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25299 30.192L87.132 30.396",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25299 39.678L87.132 39.882",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25299 49.164L87.132 49.368",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25299 58.548L87.132 58.854",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25299 68.034L87.132 68.238",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9597 21.012V95.064",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25299 77.622H87.132",
    stroke: "#B6B6B6",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0066 80.478H74.1134C73.151 80.478 72.3708 81.2543 72.3708 82.212V90.066C72.3708 91.0237 73.151 91.8 74.1134 91.8H82.0066C82.969 91.8 83.7492 91.0237 83.7492 90.066V82.212C83.7492 81.2543 82.969 80.478 82.0066 80.478Z",
    fill: "#FFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 24.888H11.0709V26.928H13.1211V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 24.888H15.2737V26.928H17.3239V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 24.888H19.3741V26.928H21.4242V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 33.762H11.0709V35.802H13.1211V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 33.762H15.2737V35.802H17.3239V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 33.762H19.3741V35.802H21.4242V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 43.248H11.0709V45.288H13.1211V43.248Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 43.248H15.2737V45.288H17.3239V43.248Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 43.248H19.3741V45.288H21.4242V43.248Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 52.632H11.0709V54.672H13.1211V52.632Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 52.632H15.2737V54.672H17.3239V52.632Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 52.632H19.3741V54.672H21.4242V52.632Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 62.424H11.0709V64.464H13.1211V62.424Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 62.424H15.2737V64.464H17.3239V62.424Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 62.424H19.3741V64.464H21.4242V62.424Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 71.298H11.0709V73.338H13.1211V71.298Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 71.298H15.2737V73.338H17.3239V71.298Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 71.298H19.3741V73.338H21.4242V71.298Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1211 80.784H11.0709V82.824H13.1211V80.784Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 80.784H15.2737V82.824H17.3239V80.784Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4242 80.784H19.3741V82.824H21.4242V80.784Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9051 24.888H30.8549V26.928H32.9051V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2105 24.888H35.1603V26.928H37.2105V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 24.888H39.2606V26.928H41.3108V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 24.888H43.4635V26.928H45.5136V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.819 24.888H47.7688V26.928H49.819V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9193 24.888H51.8691V26.928H53.9193V24.888Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9051 33.762H30.8549V35.802H32.9051V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2105 33.762H35.1603V35.802H37.2105V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 33.762H39.2606V35.802H41.3108V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 33.762H43.4635V35.802H45.5136V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.819 33.762H47.7688V35.802H49.819V33.762Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9051 43.452H30.8549V45.492H32.9051V43.452Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2105 43.452H35.1603V45.492H37.2105V43.452Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 43.452H39.2606V45.492H41.3108V43.452Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 43.452H43.4635V45.492H45.5136V43.452Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9051 52.734H30.8549V54.774H32.9051V52.734Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2105 52.734H35.1603V54.774H37.2105V52.734Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 52.734H39.2606V54.774H41.3108V52.734Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 52.734H43.4635V54.774H45.5136V52.734Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9051 62.118H30.8549V64.158H32.9051V62.118Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2105 62.118H35.1603V64.158H37.2105V62.118Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 62.118H39.2606V64.158H41.3108V62.118Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 62.118H43.4635V64.158H45.5136V62.118Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.819 62.118H47.7688V64.158H49.819V62.118Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9193 62.118H51.8691V64.158H53.9193V62.118Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9051 72.012H30.8549V74.052H32.9051V72.012Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2105 72.012H35.1603V74.052H37.2105V72.012Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3108 72.012H39.2606V74.052H41.3108V72.012Z",
    fill: "#B6B6B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7984_929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 102,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadMedicalCertificate);
export default __webpack_public_path__ + "static/media/bad_medicalCertificate.663496a78a39412338b931cd87cda560.svg";
export { ForwardRef as ReactComponent };